import { ActionType } from '../constants/ActionTypes'
export default function popupsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_POPUP_BEGIN:
            return {
                ...state,
                isLoading: true,
            }
        case ActionType.GET_POPUP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                popup: action.payload.data
            }
        case ActionType.GET_POPUP_ERROR:
            return {
                ...state,
                isLoading: false,
            }
        case ActionType.CHANGE_POPUP_SETTINGS:
            return {
                ...state,
                popup: {
                    ...state.popup,
                    ...action.payload
                }
            }

        case ActionType.SHOW_CUSTOM_POPUP:
            return {
                ...state,
                customPopupAlias: action.payload
            }
        case ActionType.HIDE_CUSTOM_POPUP:
            return {
                ...state,
                customPopupAlias: null,
                popup: null
            }
        default:
            return state;
    }

}

